var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCalendarDelivery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 61,
    viewBox: "0 0 62 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2831 27.5661C21.6191 27.5661 27.5661 21.6191 27.5661 14.2831C27.5661 6.94703 21.6191 1 14.2831 1C6.94703 1 1 6.94703 1 14.2831C1 21.6191 6.94703 27.5661 14.2831 27.5661Z",
    stroke: "#1ED760",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5964 16.9388H14.2832V7.64062",
    stroke: "#1ED760",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5059 32.8789H53.601C54.7242 32.8788 55.7261 33.585 56.1035 34.6429L60.8456 47.926C61.1365 48.7413 61.0118 49.6473 60.5115 50.3538C60.0113 51.0603 59.1981 51.4788 58.3324 51.4752H55.2321",
    stroke: "#1ED760",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6658 51.4763H43.5428L43.5189 27.5668C43.5189 26.0996 42.3295 24.9102 40.8623 24.9102H30.2358",
    stroke: "#1ED760",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2832 32.8789V48.8186C14.2832 50.2858 15.4726 51.4752 16.9398 51.4752H21.1665",
    stroke: "#1ED760",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.4756 56.7882C53.6765 56.7882 55.4606 55.0041 55.4606 52.8033C55.4606 50.6025 53.6765 48.8184 51.4756 48.8184C49.2748 48.8184 47.4907 50.6025 47.4907 52.8033C47.4907 55.0041 49.2748 56.7882 51.4756 56.7882Z",
    stroke: "#1ED760",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.9095 56.7882C27.1103 56.7882 28.8944 55.0041 28.8944 52.8033C28.8944 50.6025 27.1103 48.8184 24.9095 48.8184C22.7087 48.8184 20.9246 50.6025 20.9246 52.8033C20.9246 55.0041 22.7087 56.7882 24.9095 56.7882Z",
    stroke: "#1ED760",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1 38.1934L8.96984 38.2066",
    stroke: "#1ED760",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4.98486 43.5059L8.96978 43.5191",
    stroke: "#1ED760",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M7.6416 48.8184L8.96991 48.8316",
    stroke: "#1ED760",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1172 40.8496H43.5059",
    stroke: "#1ED760",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5352 51.4766H47.7379",
    stroke: "#1ED760",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalendarDelivery);
export default __webpack_public_path__ + "static/media/icon-calendar-delivery.240cd137.svg";
export { ForwardRef as ReactComponent };